import type { SliderProps as MuiSliderProps } from "@mui/material";

import * as sx from "./index.sx";
import { SliderThumb } from "./slider-thumb";

export type SliderProps = Omit<MuiSliderProps, "slots"> & sx.MinMaxProps;

const slots = {
  thumb: SliderThumb,
};

/**
 * Custom Slider implementation adds thumb dots and disabled end zones
 */
export const Slider = ({
  min = 0,
  max = 100,
  enabledMin = min,
  enabledMax = max,
  onChange,
  onChangeCommitted,
  ...props
}: SliderProps) => {
  const boundValue = (value: number | number[]) => {
    const values = Array.isArray(value) ? value : [value];
    const boundedValues = values.map((val) =>
      Math.min(Math.max(val, enabledMin), enabledMax),
    );
    return Array.isArray(value) ? boundedValues : boundedValues[0];
  };

  return (
    <sx.Slider
      valueLabelDisplay="auto"
      {...props}
      slots={slots}
      min={min}
      max={max}
      enabledMin={enabledMin}
      enabledMax={enabledMax}
      onChange={(event, value, activeThumb) => {
        onChange?.(event, boundValue(value), activeThumb);
      }}
      onChangeCommitted={(event, value) => {
        onChangeCommitted?.(event, boundValue(value));
      }}
    />
  );
};
